<template>
    <v-layout class="sponsor__layoutview">
        <status-overlay :action="loadingAction"></status-overlay>
        <v-layout row wrap align-center class="pa-1">
            <v-flex v-if="!loadingAction.pending && !loadingAction.failed && (!sponsorLists || !sponsorLists.length)"
                    data-qe-id="sponsors_no-sponsors_message"
                 class="sponsor__no-sponsors pa-4">
                {{sponsorsConstants.NO_SPONSORS}}
            </v-flex>
            <div v-for="(sponsorItem, index) in sponsorLists" :key="sponsorItem.id"
                class="ma-2 sponsor-item" :style="logoStyles(sponsorItem)">
                <a :href="normalizeUrl(sponsorItem.url)" target="_blank" class="fill"
                   :data-qe-id="`sponsors_item_${index}_link`">
                    <v-img :src="sponsorItem.logo.url" contain class="fill"></v-img>
                </a>
            </div>
        </v-layout>
        
        <sponsor-dialog :state="dialogState" :sponsors="sponsorLists" :saveactionname="saveActionName" :saveactionmodulename="saveActionModuleName"></sponsor-dialog>
    </v-layout>
</template>
<script>
    import { mapState, mapGetters } from 'vuex';
    import { storeAction } from '@/store/storeActions.constant';
    import { storeGetters } from '@/store/storeGetters.constant';
    import { normalizeUrl } from '@/common/utils/utils';
    import sponsorsConstants from './sponsors.constant';
    import SponsorDialog from '../SponsorCard/SponsorDialog';
    import StatusOverlay from '../../StatusOverlay/StatusOverlay';

    const LOGO_UNIT_PX = 100;

    export default {
        name: 'SponsorCard',
        components: {
            SponsorDialog,
            StatusOverlay,
        },
        data: () => ({
            LOGO_UNIT_PX,
            sponsorsConstants,
            saveActionName: storeAction.postChapterSponsor,
            saveActionModuleName: 'sponsor',
        }),
        props: {
            dialogState: {
                type: Object,
                required: true,
            },
        },
        methods: {
            normalizeUrl(url) {
                return normalizeUrl(url);
            },
            logoStyles(sponsorItem) {
                const height = `${LOGO_UNIT_PX}px`;
                const width = `${sponsorItem.w * LOGO_UNIT_PX}px`;
                return { height, width };
            },
       },
        computed: {
            ...mapGetters({
                sponsorLists: `sponsor/${storeGetters.sponsorLists}`,
            }),
            ...mapState('actionState', ['actions']),
            loadingAction() {
                return this.actions[storeAction.getSponsorsList];
            },
        },
    };
</script>

<style lang="scss" scoped>
.sponsor {
    &__layoutview {
        position: relative;
        min-height: 160px;
    }

    &__no-sponsors {
        text-align: center;
        font-size: 1.2em;
    }
}

.sponsor-item .fill {
    display: block;
    width: 100%;
    height: 100%;
}
</style>
